import React, { useEffect, useRef } from "react";
import { useState } from "react";

import styles from "./MeetingNotes.module.css";

const noOp = () => {};

const MeetingNotes = ({ notes, onSave = noOp, isSaving }) => {
  const textRef = useRef();
  const [hasSavedNotesCompleted, setHasSavedNotesCompleted] = useState();
  const [fadeOut, setFadeOut] = useState(false);
  const saveNotes = (e) => {
    e.preventDefault();
    setHasSavedNotesCompleted(false);
    onSave(textRef.current.value);
  };

  // Manages the "Saved" text after the notes have completed saving
  useEffect(() => {
    let tId;
    if (isSaving) {
      return;
    }

    if (hasSavedNotesCompleted) {
      tId = setTimeout(() => {
        setFadeOut(true);
      }, 1500);
    } else if (hasSavedNotesCompleted === false) {
      setHasSavedNotesCompleted(true);
      setFadeOut(false);
    }

    return () => clearTimeout(tId);
  }, [isSaving, hasSavedNotesCompleted]);

  return (
    <div className="card my-3 shadow">
      <h5 className="card-header">Meeting Notes</h5>
      <div className="card-body">
        <form onSubmit={saveNotes}>
          <div className="form-group">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="8"
              ref={textRef}
              defaultValue={notes}
              disabled={isSaving}
            ></textarea>
          </div>
          <div className="d-flex align-items-center">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSaving}
            >
              {isSaving ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm mr-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Saving Notes...
                </>
              ) : (
                <>Save Notes</>
              )}
            </button>
            {hasSavedNotesCompleted === true && !isSaving && (
              <span
                className={`
                ${styles.savedMessage} 
                text-success 
                d-inline-block 
                ml-2 
                ${fadeOut ? styles.fadeOut : styles.fadeIn}
              `}
              >
                Saved.
              </span>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default MeetingNotes;
